import { render } from "./SortHoldings.vue?vue&type=template&id=40273f30&scoped=true"
import script from "./SortHoldings.vue?vue&type=script&lang=js"
export * from "./SortHoldings.vue?vue&type=script&lang=js"

import "./SortHoldings.vue?vue&type=style&index=0&id=40273f30&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40273f30"]])

export default __exports__